module.exports = __webpack_public_path__ + "static/media/peter-qa.04ae968c.png";